import { render, staticRenderFns } from "./UserBlockDropdown.vue?vue&type=template&id=06ad77cc&"
import script from "./UserBlockDropdown.vue?vue&type=script&lang=js&"
export * from "./UserBlockDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports